import path from 'path';
import camelCase from 'lodash.camelcase';

export default ({
    types: t
}) => {
    const isAnnonFunctionDecl = (declaration) => {
        return (declaration.type === 'FunctionExpression' || declaration.type === 'FunctionDeclaration') &&
               !(declaration.id && declaration.id.name);
    };

    const isAnnonClassDecl = (declaration) => {
        return (declaration.type === 'ClassExpression' || declaration.type === 'ClassDeclaration') &&
               !(declaration.id && declaration.id.name);
    };

    const isArrowFunctionDecl = (declaration) => {
        return declaration.type === 'ArrowFunctionExpression';
    };

    const deduceName = (pluginPass, scope) => {
        const filename = pluginPass && pluginPass.file && pluginPass.file.opts && pluginPass.file.opts.filename;

        let name = filename;
        name = name && path.basename(name).replace(/\.jsx?$/, '');
        if (name === 'index') {
            const dirname = path.basename(path.dirname(filename));
            if (dirname && dirname !== '.') name = dirname;
        }
        name = name && camelCase(name);

        if (/^[0-9]/.test(name)) {
            name = '_' + name;
        }

        if (!t.isValidIdentifier(name)) {
            throw Error('Invalid identifier "' + name + '".');
        }

        return resolveClashingName(name, scope);
    };

    const resolveClashingName = (name, scope) => {
        let index,
            resolvedName;

        index = 0;
        resolvedName = name;
        while (scope.hasBinding(resolvedName) && index < 100) {
            resolvedName = name + index++;
        }
        if (index > 100) {
            throw Error('Couldn\'t resolve clashing name "' + name + '".');
        }
        return resolvedName;
    };

    return {
        visitor: {
            ExportDefaultDeclaration (path, pluginPass) {
                const declaration = path.node.declaration;

                if (isAnnonClassDecl(declaration) || isAnnonFunctionDecl(declaration)) {
                    // replace
                    declaration.id = t.identifier(deduceName(pluginPass, path.scope));
                }

                if (isArrowFunctionDecl(declaration)) {
                    path.get('declaration').arrowFunctionToShadowed();
                    declaration.id = t.identifier(deduceName(pluginPass, path.scope))
                }

                if (
                  pluginPass && pluginPass.opts && pluginPass.opts.compose
                  && t.isCallExpression(declaration)
                  && declaration.arguments.length === 1
                  && t.isArrowFunctionExpression(declaration.arguments[0])
                ) {
                  path.get('declaration.arguments.0').arrowFunctionToShadowed();
                  declaration.arguments[0].id = t.identifier(deduceName(pluginPass, path.scope))
                }
            }
        }
    };
};
